import type { SvgIconComponent } from "@mui/icons-material";
import { Grid } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";

interface Props {
  Icon: SvgIconComponent | null;
  fieldName: string;
  FieldValue: React.ReactNode;
}

const WorkbookDetailsField = ({ Icon, fieldName, FieldValue }: Props) => {
  return (
    <Grid container sx={{ gap: 1.5, flexWrap: "nowrap" }}>
      <Grid size={6} sx={{ display: "flex", py: 1, alignItems: "center", gap: 1.5 }}>
        {Icon && <Icon sx={{ color: "secondary.light" }} />}
        <TypographyTooltipEllipsis text={fieldName} />
      </Grid>
      <Grid size={6} sx={{ display: "flex", alignItems: "center", py: 1, px: 1.25, gap: 1.25 }}>
        {FieldValue}
      </Grid>
    </Grid>
  );
};

export default WorkbookDetailsField;
